import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../../../../components/ui/dialog';
import { Button } from '../../../../components/ui/button';
import { Input } from '../../../../components/ui/input';
import { Label } from '../../../../components/ui/label';

export const DeleteWithReasonDialog = ({
  open,
  onOpenChange,
  pendingDeleteAction,
  deleteReason,
  setDeleteReason,
  executeDelete,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md">
      <DialogHeader>
        <DialogTitle>Confirm Deletion</DialogTitle>
      </DialogHeader>
      <div className="space-y-4 py-2">
        <p className="text-sm text-gray-600">
          {pendingDeleteAction?.type === 'bulk'
            ? `You are about to delete ${pendingDeleteAction?.ids?.size} transaction(s). This action will be logged.`
            : 'You are about to delete this transaction. This action will be logged.'}
        </p>
        <div className="space-y-1">
          <Label className="text-sm font-medium">Reason for deletion *</Label>
          <Input
            value={deleteReason}
            onChange={(e) => setDeleteReason(e.target.value)}
            placeholder="e.g. Duplicate entry, Error correction..."
            data-testid="delete-reason-input"
          />
        </div>
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
        <Button variant="destructive" onClick={executeDelete} disabled={!deleteReason.trim()} data-testid="confirm-delete-btn">
          Delete
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
